import React from "react";
import { Redirect, useParams } from "react-router-dom";

import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { ProcManagementR } from "../route";
import {
  ContextProps,
  ProcManagementEditService,
} from "../../../../application/service/proc-management/procedure-edit";
import { PortalTemplate } from "../../../template/portal/default-template";
import { Content } from "../../../organisms/proc-management/form";
import { useAuthContextV2 } from "../../../../auth-state";
import { isProcedure } from "../../../../application/domain/proc-management";
import { TtzkPortalR } from "../../ttzk-portal/route";

const ProcManagementProcedureEdit: React.FC<ContextProps> = ({
  procedure,
  smartApply,
  find,
  fetchSmartApplyStatus,
  clearSmartApplyStatus,
  onSave,
  onChange,
  onFileAttached,
  isUpdating,
  getFileUploading,
  publish,
  unPublish,
  archive,
  copy,
  publishProcAndSmartApply,
  setOrganization,
  canEditGroupId,
  attachGroupToProc,
  setAuthCtx,
  canManipulateProc,
  shouldDisplayError,
  validationErrors,
  smartApplyValidationResult,
}) => {
  const { procId } = useParams<{ procId: string }>();
  const pageTitle =
    typeof procedure.name === "string" && procedure.name.length > 0
      ? procedure.name
      : procId;

  const { auth } = useAuthContextV2();
  const orgId = auth.data?.orgId;
  React.useEffect(() => {
    if (typeof orgId === "string") {
      setOrganization(orgId);
    }
  }, [orgId, setOrganization]);

  React.useEffect(() => {
    find(procId);
  }, [find, fetchSmartApplyStatus, procId]);

  const smartApplyId = procedure.onlineInfo?.grafferSmartApplyInfo?.procedureId;
  React.useEffect(() => {
    if (smartApplyId && smartApplyId !== "") {
      fetchSmartApplyStatus(smartApplyId);
    } else {
      clearSmartApplyStatus();
    }
  }, [fetchSmartApplyStatus, smartApplyId, clearSmartApplyStatus]);

  React.useEffect(() => {
    setAuthCtx(auth.data);
  }, [setAuthCtx, auth]);

  return (
    <PortalTemplate
      breadcrumbs={[
        { to: TtzkPortalR.Home.link({}), title: "Graffer ポータル" },
        { to: ProcManagementR.ProcedureList.link({}), title: "手続き一覧" },
        {
          to: ProcManagementR.ProcedureDetail.link({ procId }),
          title: pageTitle,
        },
        { to: ProcManagementR.ProcedureEdit.link({ procId }), title: "編集" },
      ]}
    >
      {isProcedure(procedure) ? (
        <Content
          procedure={procedure}
          smartApply={smartApply}
          onPressSave={onSave}
          onChange={onChange}
          onFileAttached={onFileAttached}
          isUpdating={isUpdating}
          getFileUploading={getFileUploading}
          publish={publish}
          unPublish={unPublish}
          archive={archive}
          copy={copy}
          publishProcAndSmartApply={publishProcAndSmartApply}
          canEditGroupId={canEditGroupId()}
          onAddGroup={attachGroupToProc}
          disabled={!canManipulateProc()}
          shouldDisplayError={shouldDisplayError}
          validationErrors={validationErrors}
          smartApplyValidationResult={smartApplyValidationResult}
        />
      ) : null}
    </PortalTemplate>
  );
};

export const ProcManagementProcedureEditContainer = connectPageService(
  ProcManagementProcedureEdit,
  () => new ProcManagementEditService(),
);

export const RedirectToProcManagementProcedureEditContainer: React.FC = () => {
  const { procId } = useParams<{ procId: string }>();
  return <Redirect to={ProcManagementR.ProcedureEdit.link({ procId })} />;
};
